module.exports = __webpack_public_path__ + "img/kenchan.b2526f0d.png";